import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { FETCH_TOAST_MESSAGES, type IToastMessage, MUTATE_TOAST_MESSAGES } from "services/store/types";

export function useQueryToast() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: [FETCH_TOAST_MESSAGES],

    queryFn: (): Array<IToastMessage> => {
      const state: Array<IToastMessage> = queryClient.getQueryData([FETCH_TOAST_MESSAGES]) ?? [];
      return state;
    },
  });
  return query;
}

export function useMutationRemoveToastMessage() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: [MUTATE_TOAST_MESSAGES],
    mutationFn: async (message: IToastMessage) => {
      return queryClient.setQueryData<Array<IToastMessage>>(
        [FETCH_TOAST_MESSAGES],
        (state) => state?.filter((item) => item.id !== message.id) || [],
      );
    },
  });
  return mutation;
}
